// **  Initial State
const initialState = {
    allData: [],
    selected: null
}

const pagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_TEXT':
            return { ...state, allData: action.data }
        case 'SELECTED_TEXT':
            return { ...state, selected: action.data }
        case 'UPDATED_TEXT':
            return { ...state, selected: state.selected.concat(action.data) }
        case 'DELETE_TEXT':
            return {
                ...state,
                allData: state.allData.filter(news => {return news.id !== action.data.deleteitems} )
            }
        default:
            return state
    }
}

export default pagesReducer
